import Main from '../../pages/Main.vue';
import PageName from '../../constant/PageName';
import PermissionIds from '../../constant/PermissionIds';
// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
  
  {
    path: '/',
    icon: 'md-home',
    name: 'Home',
    title: '首页',
    component: Main,
    children: [
      {
        path: 'home',
        title: '首页',
        name: PageName.PAGE_HOME_INDEX,
        component: function (resolve) {
          require(['../../pages/Home.vue'], resolve)
        },
      },
    ]
  },


];




// WEBPACK FOOTER //
// ./src/router/routers/A_home.js